import { Head } from 'components/Head';
import { Link } from 'react-router-dom';
import LogoDefault from 'assets/logo.svg';

export const MainLayout = ({ title, description, children }) => {
  return (
    <>
      <Head title={title} description={description} />

      <div className="min-h-screen bg-[#f6f1e8] text-[#1b140f]">
        <div className="fixed inset-0 -z-10 bg-[radial-gradient(circle_at_top_left,_rgba(201,124,66,0.18),_transparent_28%),radial-gradient(circle_at_80%_15%,_rgba(18,84,78,0.12),_transparent_24%),linear-gradient(135deg,_#f8f2e8_0%,_#efe1cf_48%,_#ead7c2_100%)]" />
        <div className="fixed inset-0 -z-10 opacity-[0.08] [background-image:linear-gradient(rgba(27,20,15,0.8)_1px,transparent_1px),linear-gradient(90deg,rgba(27,20,15,0.8)_1px,transparent_1px)] [background-size:72px_72px]" />

        <header className="sticky top-0 z-50 border-b border-[#1b140f]/10 bg-[#f6f1e8]/80 backdrop-blur-xl">
          <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6">
            <Link to="/" className="flex items-center gap-3">
              <div className="relative">
                <img
                  src={LogoDefault}
                  alt="Fundo Logo"
                  className="h-10 w-10 rounded-full object-contain"
                />
                <div className="absolute inset-0 rounded-full ring-8 ring-[#1b140f]/5" />
              </div>
              <div>
                <span className="block text-[0.72rem] font-semibold uppercase tracking-[0.35em] text-[#8b5e3c]">
                  Fundo
                </span>
              </div>
            </Link>

            <nav className="flex items-center">
              <Link
                to="/company"
                className="rounded-full border border-[#1b140f]/10 bg-white/50 px-5 py-2.5 text-sm font-medium text-[#1b140f] transition hover:-translate-y-0.5 hover:border-[#1b140f]/20 hover:bg-white"
              >
                Company
              </Link>
            </nav>
          </div>
        </header>

        <main className="mx-auto max-w-7xl px-6 py-10">{children}</main>

        <footer className="mt-16 border-t border-[#1b140f]/10 bg-[#efe4d3]/70">
          <div className="mx-auto grid max-w-7xl gap-6 px-6 py-10 text-sm text-[#4f4034] md:grid-cols-4 md:items-center">
            <div className="flex items-center">
              <img
                src={LogoDefault}
                alt="Fundo Logo"
                className="h-10 w-10 rounded-full object-contain"
              />
            </div>

            <address className="not-italic leading-6">
              Fundo Labs, Kampala <br /> Uganda
            </address>
            <div className="flex flex-col">
              <Link to="/terms" className="transition hover:text-[#1b140f]">
                Terms and Conditions
              </Link>
              <Link to="/privacy" className="transition hover:text-[#1b140f]">
                Privacy Policy
              </Link>
              <Link to="/csae" className="transition hover:text-[#1b140f]">
                Child Safety
              </Link>
            </div>

            <div className="flex flex-col">
              <Link to="/financial-services-disclaimer" className="transition hover:text-[#1b140f]">
                Financial Services Disclaimer
              </Link>
              <Link to="/marketplace-terms" className="transition hover:text-[#1b140f]">
                Marketplace Terms
              </Link>
              <Link to="/risk-disclosure" className="transition hover:text-[#1b140f]">
                Risk Disclosure
              </Link>
            </div>
          </div>
          <div className="text-center text-xs mb-12">
            All rights reserved . Fundo 2026 . Product of Ashita Creatives
          </div>
        </footer>
      </div>
    </>
  );
};
